import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import {
  ListItem,
  ListItemIcon as MaterialListItemIcon,
  ListItemText as MaterialListItemText,
} from '@material-ui/core';

const DrawerLink = ({
  isActive, icon: Icon, path, title,
}) => (
  <RouterLink to={path}>
    <ListItem button>
      <ListItemIcon selected={isActive}>
        <Icon size={24} />
      </ListItemIcon>
      <ListItemText primary={title} selected={isActive} />
    </ListItem>
  </RouterLink>
);

DrawerLink.propTypes = {
  isActive: PropTypes.bool,
  icon: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

DrawerLink.defaultProps = {
  isActive: false,
};

export default DrawerLink;

const RouterLink = styled(Link)`
  text-decoration: none;
`;

const ListItemIcon = styled(MaterialListItemIcon)`
  ${props => props.selected
    && css`
      fill: ${props.theme.palette.secondary.main} !important;
    `};
`;

const ListItemText = styled(MaterialListItemText)`
  & > span {
    ${props => props.selected
      && css`
        color: ${props.theme.palette.secondary.main} !important;
      `};
  }
`;



// WEBPACK FOOTER //
// ./src/components/AppShell/components/DrawerLink.js